module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_zigbang_m2.a88090d7989adc726df1e6f76e21299b.png";